<div
    *ngrxLet="{
        qualification: qualification$,
        isExpired: isExpired$,
        isAboutToExpire: isAboutToExpire$,
    } as vm"
    class="qualification"
    [class.expired]="vm.isExpired"
    [class.about-to-expire]="vm.isAboutToExpire"
>
    <ng-container [ngSwitch]="vm.qualification.category">
        <dtm-ui-icon *ngSwitchCase="OperationScenarioCategory.Open" name="shield" class="shield"></dtm-ui-icon>
        <dtm-ui-icon *ngSwitchDefault name="shield-cross" class="shield"></dtm-ui-icon>
    </ng-container>
    <div class="qualification-value">
        <div class="qualification-name" [ngSwitch]="true">
            <h6 class="header">{{ vm.qualification.name }}</h6>
            <dtm-ui-popover
                *ngSwitchCase="!!vm.qualification.statusReason"
                [popoverText]="vm.qualification.statusReason ?? ''"
            ></dtm-ui-popover>
            <dtm-ui-popover *ngSwitchCase="vm.isExpired">
                <div #expiredTooltipSlotContent>
                    <ng-content select="[expiredTooltipSlot]"></ng-content>
                </div>
                <ng-container *ngIf="expiredTooltipSlotContent | isEmptyElement">
                    {{ "dtmUi.qualificationBadge.expiredTooltip" | transloco }}
                </ng-container>
            </dtm-ui-popover>
            <dtm-ui-popover *ngSwitchCase="vm.isAboutToExpire">
                <div #aboutToExpireTooltipSlotContent>
                    <ng-content select="[aboutToExpireTooltipSlot]"></ng-content>
                </div>
                <ng-container *ngIf="aboutToExpireTooltipSlotContent | isEmptyElement">
                    {{ "dtmUi.qualificationBadge.aboutToExpireTooltip" | transloco }}
                </ng-container>
            </dtm-ui-popover>
        </div>
        <div class="details">
            <span class="reason" *ngIf="vm.qualification.status === QualificationStatus.Suspended; else expirationDateTemplate">
                {{ "dtmUi.qualificationBadge.suspendedLabel" | transloco }}
            </span>
            <ng-template #expirationDateTemplate>
                {{ "dtmUi.qualificationBadge.validityTermLabel" | transloco : { date: vm.qualification.expirationDate | localizeDate } }}
            </ng-template>
        </div>
        <div class="details" *ngIf="vm.qualification.uavs?.length">
            {{ "dtmUi.qualificationBadge.uavsLabel" | transloco : { amount: (vm.qualification.uavs ?? []).length | localizeNumber } }}
            <dtm-ui-popover>
                {{ (vm.qualification.uavs ?? []).join(", ") }}
            </dtm-ui-popover>
        </div>
    </div>
</div>
